// extracted by mini-css-extract-plugin
export var menuIcon = "_m6-0";
export var menuIconInline = "_m6-1";